<template lang="pug">
v-alert(
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")

</template>

<script>
import { VAlert } from 'vuetify/lib';

export default {
  components:  { VAlert },
  props: {
    noTonal: { // use when set @text: true,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const { noTonal, $attrs } = this;
      return {
        icon: '$ui-information-circle',
        text: true,
        class: [
          'dv-alert',
          ...noTonal ? ['dv-alert--no-tonal'] : [],
          'mb-0',
          'pa-4',
          'ui-body-2',
        ],
        ...$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-alert {
  border-radius: 16px;
  &--no-tonal {
    &::before {
      display: none !important;
    }
  }
  &::v-deep .v-alert__wrapper {
    column-gap: 8px;
    & > .v-icon {
      margin-right: 0px;
      font-size: 20px;
      width: 20px;
      height: 20px;
      & > .v-icon__component {
        font-size: 20px;
        width: 20px;
        height: 20px;
        flex: unset;
      }
    }
  }
}
</style>
